import TrustLanding from "@/components/landing/TrustLanding";

const Index = () => <TrustLanding />;

export default Index;
